<template>
    <div class="flex flex-col items-center gap-3.5 text-center py-2">
        <span class="launched-badge" aria-hidden="true">
            <i class="bi bi-check-lg" aria-hidden="true"></i>
        </span>
        <h2 class="display-serif text-valence-stone-900">Reviewers invited!</h2>
        <p v-if="selfAssessEnabled" class="body-small text-valence-stone-500 max-w-[460px]">
            Rate yourself on the same questions your reviewers are answering to see where the gaps lie.
        </p>
        <p v-else class="body-small text-valence-stone-500 max-w-[460px]">Your reviewers have been invited. We'll let you know as their feedback comes in.</p>
        <p v-if="closesDate" class="scaffold-details-small text-valence-stone-500">This 360 closes on {{ closesDate }}.</p>

        <BaseCard v-if="selfAssessEnabled" padding="md" class="w-full max-w-[460px] mt-3 flex items-center justify-between gap-4 text-left">
            <div class="flex flex-col gap-0.5 min-w-0">
                <span class="scaffold-body-small text-valence-stone-500">Next step in your 360</span>
                <span class="body-semibold text-valence-stone-900">Complete your self-assessment</span>
                <span v-if="closes" class="scaffold-details-small text-valence-stone-500">{{ closes }}</span>
            </div>
            <BaseButton theme="primary" size="sm" class="base-btn-dark" @click="emit('start')">Start</BaseButton>
        </BaseCard>
        <BaseButton v-else theme="primary" size="sm" class="base-btn-dark mt-3" @click="emit('done')">Done</BaseButton>
    </div>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import BaseCard from "~vue/components/BaseCard.vue";
import { closesLabel, formatDate } from "~vue/utils/threeSixty";
import { computed } from "vue";

interface Props {
    selfAssessEnabled: boolean;
    closesAt?: string | null;
}

const { selfAssessEnabled, closesAt = null } = defineProps<Props>();

const closes = computed(() => closesLabel(closesAt));
const closesDate = computed(() => formatDate(closesAt, "long"));
const emit = defineEmits<{ start: []; done: [] }>();
</script>

<style scoped>
.launched-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    border-radius: 9999px;
    background: #e84c8d;
    color: #fff;
    font-size: 30px;
    animation: launched-pop 0.45s ease-out both;
}

@keyframes launched-pop {
    0% {
        transform: scale(0.6);
        opacity: 0;
    }

    60% {
        transform: scale(1.08);
    }

    100% {
        transform: scale(1);
        opacity: 1;
    }
}

@media (prefers-reduced-motion: reduce) {
    .launched-badge {
        animation: none;
    }
}
</style>
